// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import EmailFillSvg from '@rsuite/icon-font/lib/file/EmailFill';
var EmailFill = createSvgIcon({
  as: EmailFillSvg,
  ariaLabel: 'email fill',
  category: 'file',
  displayName: 'EmailFill'
});
export default EmailFill;